export default [
    {
        path: '/ecardShop',
        name: 'ecardShop',
        meta: {page:"userCenter"},
        component: () => import('@/views/EcardShop')
    },
    {
        path: '/ecardSearch',
        name: 'ecardSearch',
        meta: {page:"userCenter"},
        component: () => import('@/views/EcardShop/ecardSearch')
    },
    {
        path: '/ecardDetail',
        name: 'ecardDetail',
        meta: {page:"userCenter"},
        component: () => import('@/views/EcardShop/ecardDetail')
    },
    {
        path: '/ecardBackPack',
        name: 'ecardBackPack',
        meta: {page:"userCenter"},
        component: () => import('@/views/EcardShop/ecardBackPack')
    }
]